(function () {
  function getPathFromContext() {
    return sessionStorage.getItem('algolia_breadcrumb_path') || null;
  }

  function getCollectionFromContext() {
    var storedUrl = sessionStorage.getItem('algolia_breadcrumb_collection_url');
    var storedTitle = sessionStorage.getItem('algolia_breadcrumb_collection_title');
    if (!storedUrl || !storedTitle) return null;
    // Mega-menu ancestor chain stored by the PLP — the PDP trail mirrors the
    // collection PLP breadcrumb exactly.
    var parents = [];
    try {
      parents = JSON.parse(sessionStorage.getItem('algolia_breadcrumb_collection_parents') || '[]');
      if (!Array.isArray(parents)) parents = [];
    } catch (e) { parents = []; }
    return { url: storedUrl, title: storedTitle, parents: parents };
  }

  function getSearchQueryFromContext() {
    return sessionStorage.getItem('algolia_breadcrumb_search_query') || null;
  }

  function getPathFromAlgolia(handle) {
    return new Promise(function (resolve) {
      function run() {
        try {
          var index = window.algoliaShopify.searchClient.initIndex('shopify_products');
          index.search('', {
            filters: 'handle:' + handle,
            hitsPerPage: 1,
          }).then(function (result) {
            if (!result.hits || !result.hits.length) return resolve(null);
            var hit = result.hits[0];
            var path = '';
            for (var lvl = 0; lvl < 10; lvl++) {
              var val = hit['meta.custom.algolia_categories.categories.lvl' + lvl];
              if (val) {
                path = Array.isArray(val) ? val[0] : val;
              } else {
                break;
              }
            }
            resolve(path || null);
          }).catch(function () { resolve(null); });
        } catch (e) { resolve(null); }
      }

      if (window.algoliaShopify && window.algoliaShopify.searchClient) {
        run();
      } else {
        document.addEventListener('algolia.helpers.initialize', run, { once: true });
      }
    });
  }

  function getPlpUrl() {
    return sessionStorage.getItem('algolia_breadcrumb_plp_url') || null;
  }

  function buildBreadcrumbs(container, path, productTitle, collection, searchQuery) {
    var levels = path ? path.split(' > ') : [];

    var nav = document.createElement('nav');
    nav.className = 'breadcrumbs breadcrumbs-pdp';
    nav.setAttribute('role', 'navigation');
    nav.setAttribute('aria-label', 'breadcrumbs');

    var ol = document.createElement('ol');
    ol.className = 'breadcrumbs__list';

    // Home
    var homeLi = document.createElement('li');
    homeLi.className = 'breadcrumbs__item';
    var homeA = document.createElement('a');
    homeA.className = 'breadcrumbs__link';
    homeA.href = '/';
    homeA.textContent = 'Home';
    homeLi.appendChild(homeA);
    ol.appendChild(homeLi);

    var plpUrl = getPlpUrl();

    // Parent collection crumbs — the collection's mega-menu ancestors, so the
    // PDP shows the same trail as the collection PLP it came from.
    if (collection && collection.parents) {
      collection.parents.forEach(function (parent) {
        if (!parent || !parent.title) return;
        var pSep = document.createElement('li');
        pSep.className = 'breadcrumbs__separator';
        pSep.setAttribute('aria-hidden', 'true');
        pSep.textContent = '/';
        ol.appendChild(pSep);

        var pLi = document.createElement('li');
        pLi.className = 'breadcrumbs__item';
        if (parent.url && parent.url !== '#') {
          var pA = document.createElement('a');
          pA.className = 'breadcrumbs__link';
          pA.href = parent.url;
          pA.textContent = parent.title;
          pLi.appendChild(pA);
        } else {
          // Mega-menu headers without a real destination stay unclickable.
          var pSpan = document.createElement('span');
          pSpan.className = 'breadcrumbs__link';
          pSpan.textContent = parent.title;
          pLi.appendChild(pSpan);
        }
        ol.appendChild(pLi);
      });
    }

    // Collection crumb — always links to clean collection URL
    if (collection) {
      var collSep = document.createElement('li');
      collSep.className = 'breadcrumbs__separator';
      collSep.setAttribute('aria-hidden', 'true');
      collSep.textContent = '/';
      ol.appendChild(collSep);

      var collLi = document.createElement('li');
      collLi.className = 'breadcrumbs__item';
      var collA = document.createElement('a');
      collA.className = 'breadcrumbs__link';
      collA.href = collection.url;
      collA.textContent = collection.title;
      collLi.appendChild(collA);
      ol.appendChild(collLi);
    }

    // Search query crumb (only on search, no collection)
    if (!collection && searchQuery) {
      var sqSep = document.createElement('li');
      sqSep.className = 'breadcrumbs__separator';
      sqSep.setAttribute('aria-hidden', 'true');
      sqSep.textContent = '/';
      ol.appendChild(sqSep);

      var sqLi = document.createElement('li');
      sqLi.className = 'breadcrumbs__item';
      var sqA = document.createElement('a');
      sqA.className = 'breadcrumbs__link';
      sqA.href = plpUrl || '/search?q=' + encodeURIComponent(searchQuery);
      sqA.textContent = '"' + searchQuery + '"';
      sqLi.appendChild(sqA);
      ol.appendChild(sqLi);
    }

    // Category levels — all are links back to collection/search with refinement
    levels.forEach(function (label, i) {
      var sep = document.createElement('li');
      sep.className = 'breadcrumbs__separator';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '/';
      ol.appendChild(sep);

      var li = document.createElement('li');
      li.className = 'breadcrumbs__item';

      var a = document.createElement('a');
      a.className = 'breadcrumbs__link';
      var refinePath = levels.slice(0, i + 1).join(' > ');
      // Use the stored PLP URL (with all filter params) as base,
      // overriding the category to match this breadcrumb level.
      if (plpUrl) {
        var parts = plpUrl.split('?');
        var params = new URLSearchParams(parts[1] || '');
        params.set('category', refinePath);
        a.href = parts[0] + '?' + params.toString();
      } else if (collection) {
        a.href = collection.url + '?category=' + encodeURIComponent(refinePath);
      } else {
        a.href = '/search?q=' + encodeURIComponent(searchQuery || '') + '&category=' + encodeURIComponent(refinePath);
      }
      a.textContent = label;
      li.appendChild(a);

      ol.appendChild(li);
    });

    // Product title
    var titleSep = document.createElement('li');
    titleSep.className = 'breadcrumbs__separator';
    titleSep.setAttribute('aria-hidden', 'true');
    titleSep.textContent = '/';
    ol.appendChild(titleSep);

    var titleLi = document.createElement('li');
    titleLi.className = 'breadcrumbs__item';
    var titleSpan = document.createElement('span');
    titleSpan.className = 'breadcrumbs__link';
    titleSpan.setAttribute('aria-current', 'page');
    titleSpan.textContent = productTitle;
    titleLi.appendChild(titleSpan);
    ol.appendChild(titleLi);

    nav.appendChild(ol);

    // Replace container content
    container.innerHTML = '';
    container.appendChild(nav);
  }

  function init() {
    var container = document.querySelector('#pdp-algolia-breadcrumbs');
    if (!container) return;

    var handle = container.dataset.productHandle;
    var title = container.dataset.productTitle;
    var collection = getCollectionFromContext();
    var searchQuery = getSearchQueryFromContext();

    var path = getPathFromContext();
    if (path) {
      buildBreadcrumbs(container, path, title, collection, searchQuery);
    } else if (collection || searchQuery) {
      // Render immediately with collection/search context
      buildBreadcrumbs(container, null, title, collection, searchQuery);
      // Optionally enhance with category from Algolia
      if (handle) {
        getPathFromAlgolia(handle).then(function (algoliaPath) {
          if (algoliaPath) buildBreadcrumbs(container, algoliaPath, title, collection, searchQuery);
        });
      }
    } else if (handle) {
      // No context at all — try Algolia as last resort
      getPathFromAlgolia(handle).then(function (algoliaPath) {
        if (algoliaPath) buildBreadcrumbs(container, algoliaPath, title, null, null);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
